import { z } from 'zod';
import { UnitBaseStatusSchema } from './reservation-status.js';

// --- Reservation status (shared across features) ---

export const ReservationStatusSchema = UnitBaseStatusSchema;
export type ReservationStatus = z.infer<typeof ReservationStatusSchema>;

// --- Media format / type ---

export const MediaFormatSchema = z.enum([
  'billboard12',
  'billboard18',
  'billboard27',
  'billboard32',
  'billboard36',
  'billboard48',
  'billboard_other',
  'backlight18',
  'backlight32',
  'backlight_other',
  'citylight',
  'cityscroll',
  'highway',
  'wielki_format',
  'wall',
  'digital',
  'rm_digital',
  'slup',
  'other',
]);
export type MediaFormat = z.infer<typeof MediaFormatSchema>;

// --- Dashboard stats ---

export const DashboardStatsSchema = z.object({
  totalMedia: z.number().int().nonnegative(),
  freeMedia: z.number().int().nonnegative(),
  optionMedia: z.number().int().nonnegative(),
  reservedMedia: z.number().int().nonnegative(),
  soldMedia: z.number().int().nonnegative(),
  activeOffers: z.number().int().nonnegative(),
  pendingComplaints: z.number().int().nonnegative(),
  monthlyRevenue: z.number().nonnegative(),
});
export type DashboardStats = z.infer<typeof DashboardStatsSchema>;

// --- Recent activity entry ---

export const ActivityTypeSchema = z.enum([
  'reservation_created',
  'reservation_cancelled',
  'offer_sent',
  'offer_accepted',
  'media_imported',
  'complaint_opened',
  'complaint_resolved',
  'status_changed',
]);
export type ActivityType = z.infer<typeof ActivityTypeSchema>;

export const RecentActivitySchema = z.object({
  id: z.string(),
  type: ActivityTypeSchema,
  title: z.string(),
  description: z.string(),
  timestamp: z.string().datetime(),
  userName: z.string(),
  mediaId: z.string().optional(),
  offerId: z.string().optional(),
});
export type RecentActivity = z.infer<typeof RecentActivitySchema>;

// --- Media summary (for tables/lists) ---

/**
 * @deprecated Use `MediaUnitListItemSchema` from `./media-units` instead.
 * This schema was created for dashboard mockups and does not reflect the full
 * server-side API response shape. Kept for backward compatibility with mockups.
 */
export const MediaSummarySchema = z.object({
  id: z.string(),
  omiNumber: z.string(),
  supplierNumber: z.string(),
  format: MediaFormatSchema,
  city: z.string(),
  address: z.string(),
  region: z.string(),
  supplier: z.string(),
  widthM: z.number().nonnegative(),
  heightM: z.number().nonnegative(),
  areaM2: z.number().nonnegative(),
  illuminated: z.boolean(),
  status: ReservationStatusSchema,
  catalogPrice: z.number().nonnegative().optional(),
  latitude: z.number(),
  longitude: z.number(),
  photoUrl: z.string().optional(),
});
export type MediaSummary = z.infer<typeof MediaSummarySchema>;
